import PropTypes from "prop-types";

const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
const SHORT_MONTHS = MONTHS.map((month) => month.slice(0, 3));
const DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export const monthName = (isoDate, offset = 0) => MONTHS[(Number(isoDate.slice(5, 7)) - 1 + offset) % 12];

export const venueDay = (iso) => {
  const [year, month, day] = iso.slice(0, 10).split("-").map(Number);
  const weekday = new Date(Date.UTC(year, month - 1, day)).getUTCDay();
  return `${DAYS[weekday]}, ${SHORT_MONTHS[month - 1]} ${day}`;
};

export const venueTime = (iso) => {
  const [hours, minutes] = iso.slice(11, 16).split(":").map(Number);
  return `${hours % 12 || 12}:${String(minutes).padStart(2, "0")} ${hours < 12 ? "AM" : "PM"}`;
};

export const unanswered = (availabilityWindow) =>
  availabilityWindow.people.filter((person) => person.remindable && person.answered_count < availabilityWindow.stats.show_count);

export const availabilityWindowShape = PropTypes.shape({
  id: PropTypes.number.isRequired,
  venue_name: PropTypes.string.isRequired,
  month: PropTypes.string.isRequired,
  opens_at: PropTypes.string.isRequired,
  closes_at: PropTypes.string.isRequired,
  status: PropTypes.oneOf(["upcoming", "open", "closed"]).isRequired,
  next_opens_at: PropTypes.string,
  positions: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.number.isRequired, name: PropTypes.string.isRequired, color_hex: PropTypes.string })).isRequired,
  stats: PropTypes.shape({
    responded_count: PropTypes.number.isRequired,
    respondent_count: PropTypes.number.isRequired,
    show_count: PropTypes.number.isRequired,
    hold_count: PropTypes.number.isRequired,
    short_show_count: PropTypes.number.isRequired,
  }).isRequired,
  shows: PropTypes.arrayOf(
    PropTypes.shape({
      calendar_event_id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      date: PropTypes.string.isRequired,
      starts_at: PropTypes.string.isRequired,
      doors_at: PropTypes.string,
      room: PropTypes.string,
      hold: PropTypes.bool.isRequired,
      short: PropTypes.number.isRequired,
      cells: PropTypes.arrayOf(
        PropTypes.shape({ staff_position_id: PropTypes.number.isRequired, needed: PropTypes.number.isRequired, free: PropTypes.number.isRequired, fillable: PropTypes.number.isRequired })
      ).isRequired,
    })
  ).isRequired,
  people: PropTypes.arrayOf(
    PropTypes.shape({
      staff_member_id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      position_names: PropTypes.arrayOf(PropTypes.string).isRequired,
      answered_count: PropTypes.number.isRequired,
      available_count: PropTypes.number.isRequired,
      note: PropTypes.string,
      remindable: PropTypes.bool.isRequired,
    })
  ).isRequired,
});
